import { useState, useEffect, useMemo } from "react";
import { useMapsLibrary } from "@vis.gl/react-google-maps";

export function useAutocompleteSuggestions(inputString, delay = 300) {
    const placesLib = useMapsLibrary("places");
    const [suggestions, setSuggestions] = useState([]);

    const sessionToken = useMemo(() => {
        if (!placesLib) return null;
        return new placesLib.AutocompleteSessionToken();
    }, [placesLib]);

    useEffect(() => {
        if (!placesLib) return;

        const timeout = setTimeout(() => {
            if (!inputString) {
                setSuggestions([]);
                return;
            }

            placesLib.AutocompleteSuggestion.fetchAutocompleteSuggestions({
                input: inputString,
                sessionToken,
                includedRegionCodes: ["gb"],
            }).then((res) => setSuggestions(res.suggestions));
        }, delay);

        return () => clearTimeout(timeout);
    }, [placesLib, inputString, sessionToken, delay]);

    return { suggestions, resetSession: () => setSuggestions([]) };
}
